import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon, TruckIcon, ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import type { OrderType } from '../contexts/CartContext';
const orderTypeInfo: Record<OrderType, {
  icon: React.ReactNode;
  label: string;
  detail: string;
}> = {
  delivery: {
    icon: <TruckIcon className="w-4 h-4" data-id="element-189" />,
    label: 'Delivery',
    detail: 'Delivering to the DMV metro area · 12 noon – 8pm'
  },
  takeaway: {
    icon: <ShoppingBagIcon className="w-4 h-4" data-id="element-190" />,
    label: 'Takeaway',
    detail: '7323 Landover Rd, Hyattsville · Ready in ~30 mins'
  },
  pickup: {
    icon: <MapPinIcon className="w-4 h-4" data-id="element-191" />,
    label: 'Pickup',
    detail: '7323 Landover Rd, Hyattsville · Walk-in anytime'
  }
};
export function OrderBar() {
  const {
    orderType,
    setOrderType
  } = useCart();
  const currentInfo = orderTypeInfo[orderType];
  return <div className="bg-light border-b border-amber/20 py-6 shadow-sm relative z-40" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-194">
          <div className="flex-shrink-0 text-center md:text-left" data-id="element-195">
            <h2 className="font-heading text-3xl md:text-4xl text-victory-red tracking-wide uppercase mb-1" data-id="element-196">
              Start Your Order
            </h2>
            <AnimatePresence mode="wait" data-id="element-197">
              <motion.p key={orderType} initial={{
              opacity: 0,
              y: 5
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -5
            }} transition={{
              duration: 0.2
            }} className="font-body text-sm text-charcoal/60 flex items-center gap-1.5 justify-center md:justify-start" data-id="element-198">
                {currentInfo.icon}
                {currentInfo.detail}
              </motion.p>
            </AnimatePresence>
          </div>

          <div className="flex-1 w-full max-w-2xl flex items-center relative" data-id="element-199">
            <div className="flex w-full bg-white rounded-full p-1.5 shadow-inner border border-amber/20 relative overflow-hidden" data-id="element-200">
              {/* Animated Background Pill */}
              <motion.div className="absolute top-1.5 bottom-1.5 w-[calc(33.333%-4px)] bg-charcoal rounded-full shadow-md z-0" initial={false} animate={{
              x: orderType === 'delivery' ? 0 : orderType === 'takeaway' ? '100%' : '200%'
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} style={{
              left: '6px'
            }} data-id="element-201" />

              {(['delivery', 'takeaway', 'pickup'] as OrderType[]).map(type => <button key={type} onClick={() => setOrderType(type)} className={`flex-1 py-3 px-2 sm:px-6 rounded-full font-heading text-lg sm:text-xl tracking-wider transition-colors relative z-10 uppercase ${orderType === type ? 'text-white' : 'text-charcoal hover:text-amber'}`} data-id="element-202">
                    {type}
                  </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}